import React from 'react'
import { FormItem, FormItemTypes, Label } from 'rds'
import CheckoutFormSection from './CheckoutFormSection'

const CheckoutFormContactInformation = ({
    contactInformation,
    formErrorMessages,
    onChange,
}) => {
    return (
        <CheckoutFormSection title='Contacto'>
            <FormItem
                id='name'
                autoComplete='name'
                label='Nombre'
                onChange={event => {
                    onChange('name', event.currentTarget.value)
                }}
                value={contactInformation.name}
                requiredLabel='Campo requerido'
                required
            />
            <FormItem
                label='Correo electrónico'
                id='email'
                autoComplete='email'
                type={FormItemTypes.EMAIL}
                onChange={event => {
                    onChange('email', event.currentTarget.value)
                }}
                value={contactInformation.email}
                errorMessage={formErrorMessages.email}
            />
            <div className='rds-grid_2-columns_item'>
                <Label>Teléfono</Label>
                <div className='rds-flex'>
                    <FormItem
                        id='phonePrefix'
                        autoComplete='phone-prefix'
                        type={FormItemTypes.SELECT}
                        className='rds-m_right__sm'
                        values={[
                            {
                                label: (
                                    <span className='rds-m_right__sm'>🇺🇾</span>
                                ),
                                value: '+598',
                                id: '+598',
                            },
                        ]}
                        value={contactInformation.phonePrefix}
                        style={{ width: 'auto' }}
                        forceDropdown
                        disabled
                    />
                    <FormItem
                        id='phone'
                        autoComplete='tel-national'
                        onChange={event => {
                            onChange('phone', event.currentTarget.value)
                        }}
                        value={contactInformation.phone}
                        errorMessage={formErrorMessages.phone}
                    />
                </div>
            </div>
        </CheckoutFormSection>
    )
}

export default CheckoutFormContactInformation
